import * as React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  RadioGroup,
} from "@mui/material";
import imgurl from "./assests/images/imgurl";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import leftArrow from "./assests/images/newimages/icons/backIcon.svg";
import rightArrow from "./assests/images/newimages/icons/rightIcon.svg";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router";
import { useState } from "react";
import AlertComp from "./Alert";
import { healthAssesmentForm } from "./api/api";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export default function HealthAssessment() {
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const navigate = useNavigate();
  const isStepSkipped = (step) => skipped.has(step);
  const [firstStepValue, setFirstStepValue] = useState("");
  const [secondStepValue, setSecondStepValue] = useState({
    height: "",
    weight: "",
  });
  const [thirdStepValue, setThirdStepValue] = useState([]);
  const [open1, setOpen1] = React.useState(true);
  const [open2, setOpen2] = React.useState(false);

  const handleChangeFirstStep = (event) => {
    setFirstStepValue(event.target.value);
  };

  const handleChangeSecondStep = (event) => {
    const { name, value } = event.target;
    setSecondStepValue({
      ...secondStepValue,
      [name]: value,
    });
  };

  // const handleChangeThirdStep = (event) => {
  //   console.log(event,"::>>event")
  //   const { name, checked } = event.target;
  //   console.log(name, checked,"::>>test")
  //   setThirdStepValue((prevValues) => {
  //     if (checked) {
  //       return [...prevValues, name];
  //     } else {
  //       return prevValues.filter((item) => item !== name);
  //     }
  //   });
  // };

  const handleChangeThirdStep = (event) => {
    const { name, checked } = event.target;

    setThirdStepValue((prevValues) => {
      if (checked) {
        if (name === "None of the above") {
          return ["None of the above"];
        } else {
          return prevValues
            .filter((item) => item !== "None of the above")
            .concat(name);
        }
      } else {
        return prevValues.filter((item) => item !== name);
      }
    });
  };

  console.log(firstStepValue, "::>>firstStepValue>>");
  console.log(secondStepValue, "::>>secondStepValue>>");
  console.log(thirdStepValue, "::>>thirdStepValue>>");
  const handleNext = () => {
    let newSkipped = skipped;

    // if (activeStep === 0 && !firstStepValue) {
    //   setalertopen(true);
    //   setalertmsg("Please select above option");
    //   setTimeout(() => {
    //     setalertopen(false)
    //   }, 2000);
    //   return;
    // }
    console.log(
      secondStepValue.weight,
      secondStepValue.height,
      parseFloat(secondStepValue.weight) /
        (((parseFloat(secondStepValue.height) / 100) *
          parseFloat(secondStepValue.height)) /
          100),
      typeof parseFloat(secondStepValue.height),
      typeof parseFloat(secondStepValue.weight)
    );

    if (
      activeStep === 0 &&
      (!secondStepValue.height || !secondStepValue.weight)
    ) {
      setalertopen(true);
      setalertmsg("Please enter all the details");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    } else if (
      activeStep === 0 &&
      (secondStepValue.height || secondStepValue.weight) &&
      secondStepValue.weight /
        (((secondStepValue.height / 100) * secondStepValue.height) / 100) <
        18.5
    ) {
      setalertopen(true);
      setalertmsg(
        "We regret to inform you that we are unable to offer you treatment at this time as you are currently underweight."
      );
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }

    if (activeStep === 1) {
      console.log(thirdStepValue.includes("None of the above"), "::>>UIUI");
      if (thirdStepValue.includes("None of the above")) {
        // console.log("<<WORKINGGGG>>");
        handleSubmitHealthAssesmentForm();
        // navigate("/CompleteProfile");
      } else {
        setalertopen(true);
        setalertmsg("Sorry, We cannot move ahead with this selection");
        setTimeout(() => {
          setalertopen(false);
        }, 2000);
        return;
      }
      return; // Prevent moving to the next step when activeStep is 2
    }

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);

    // Close the alert when navigating or moving to the next step
    setalertopen(false);
  };

  // const handleNext = () => {

  //   let newSkipped = skipped;
  //   if (activeStep == 0 && !firstStepValue) {
  //     setalertopen(true);
  //     setalertmsg("Please select above option");
  //     return;
  //   }

  //   if (
  //     activeStep == 1 &&
  //     (!secondStepValue.height || !secondStepValue.weight)
  //   ) {
  //     setalertopen(true);
  //     setalertmsg("Please enter all the details");
  //     return;
  //   }

  //   if (activeStep == 2 && thirdStepValue.includes("None of the above")) {
  //     console.log("<<WORKINGGGG>>")
  //     // navigate("/CompleteProfile");

  //   }
  //   if (isStepSkipped(activeStep)) {
  //     newSkipped = new Set(newSkipped.values());
  //     newSkipped.delete(activeStep);
  //   }
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //   setSkipped(newSkipped);
  //   // Close the alert when navigating or moving to the next step
  //   setalertopen(false);
  // };

  console.log(activeStep, "::>>activeStep.>.>");
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (activeStep !== 1) {
      throw new Error("You can't skip a step that isn't optional.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleSubmitHealthAssesmentForm = async () => {
    // if(!firstname || !lastname || !email || !password){
    //     setalertopen(true)
    //     setalertmsg('Please enter all the details')
    //     return;
    // }
    setOpen2(true);
    let reqBody = {
      user_id: localStorage.getItem("user_id"),
      existing_conditions: firstStepValue,
      allergies: thirdStepValue,
      height: secondStepValue?.height,
      weight: secondStepValue?.weight,
    };
    // setLoading(true);
    try {
      const response = await axios.post(healthAssesmentForm, reqBody);
      console.log(response, "::>>response>>");
      //   setLoading(false);
      if (response.status == 200) {
        // navigate("/CompleteProfile");
        console.log(response, "::>>response inside>>");
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  function ProceedNextPg() {
    let url = "https://shop.alopexia.com/products/alopexia-hair-restoration-medicine";
    window.open(url, "_blank");
    // setOpen2(false)
    // navigate("/CompleteProfile");
  }

  return (
    <div className="photo-container main-section-container healthAssessmentReportSection">
      <div className="">
        <div
          className="d-flex justify-content-start align-items-center gap-10px bgArrowDiv"
          style={{ position: "relative" }}
        >
          <span className="backButtonDiv mt-0px" onClick={() => navigate("/resultnew")}>
            <ArrowBackOutlinedIcon
              className="arrowBackBtn"
            ></ArrowBackOutlinedIcon>
          </span>
          <div className="pageTitle">
            <h2 className="registerShortReportTitle">Health Assessment</h2>
          </div>
        </div>
      </div>
      <Box sx={{ width: "100%" }} className="MainStepperSection mt-20px">
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<StepConnector />}
        >
          {/* Step 1 */}
          <Step completed={activeStep > 0 && !isStepSkipped(0)}>
            <StepLabel>
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                Step 1
              </Typography>
            </StepLabel>
          </Step>
          {/* Step 2 */}
          {/* <Step completed={activeStep > 1 && !isStepSkipped(1)}>
            <StepLabel>
              <Typography
                variant="body2"
                align="center"
                sx={{ mt: 1 }}
              ></Typography>
            </StepLabel>
          </Step> */}
          {/* Step 3 */}
          <Step completed={activeStep > 2 && !isStepSkipped(2)}>
            <StepLabel>
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                Step 2
              </Typography>
            </StepLabel>
          </Step>
        </Stepper>

        {/* {activeStep === 3 ? (
          <Box textAlign="center" mt={3} className="stepper">
            <Typography className="color-white">
              All steps completed - you're finished
            </Typography>

            <Button
              color="inherit"
              onClick={handleReset}
              sx={{ mt: 2 }}
              className="BorderPreviewButton"
            >
              <div className="d-flex align-items-center gap-10px">
                <span> Reset View</span>
              </div>
            </Button>
          </Box>
        ) : ( */}
        <Grid container spacing={2} mt={3} className="mt-0px">
          <Grid item xs={12} className="pt-0px pl-0px">
            <div>
              {/* {activeStep === 0 && (
                  <>
                    <div className="CommBgMainCard">
                      <Card className="mainCardInput mt-40px">
                        <CardContent className="w-100 CardContentInput">
                          <Grid container spacing={2} className="">
                            <Grid item xs={12}>
                              <Typography
                                variant="h5"
                                className="assessmentQuestion"
                              >
                                How satisfied are you with your hair overall?
                              </Typography>
                            </Grid>

                            <Grid item xs={12} className="">
                              <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label="Not at all"
                                className="mainInputField"
                              />
                            </Grid>
                            <Grid item xs={12} className="">
                              <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label="A little bit"
                                className="mainInputField"
                              />
                            </Grid>
                            <Grid item xs={12} className="">
                              <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label="Somewhat"
                                className="mainInputField"
                              />
                            </Grid>
                            <Grid item xs={12} className="">
                              <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label="Quite a bit"
                                className="mainInputField"
                              />
                            </Grid>
                            <Grid item xs={12} className="">
                              <FormControlLabel
                                value="female"
                                control={<Radio />}
                                label="Very"
                                className="mainInputField"
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </div>
                  </>
                )} */}
              {/* {activeStep === 0 && (
                <div className="CommBgMainCard">
                  <Card className="mainCardInput mt-40px">
                    <CardContent className="w-100 CardContentInput">
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h5"
                            className="assessmentQuestion"
                          >
                            How satisfied are you with your hair overall?
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <RadioGroup
                            name="satisfaction"
                            value={firstStepValue}
                            onChange={handleChangeFirstStep}
                            className="mainInputField"
                          >
                            <FormControlLabel
                              value="Not at all"
                              control={<Radio />}
                              label="Not at all"
                              className="mainInputField"
                            />
                            <FormControlLabel
                              value="A little bit"
                              control={<Radio />}
                              label="A little bit"
                              className="mainInputField"
                            />
                            <FormControlLabel
                              value="Somewhat"
                              control={<Radio />}
                              label="Somewhat"
                              className="mainInputField"
                            />
                            <FormControlLabel
                              value="Quite a bit"
                              control={<Radio />}
                              label="Quite a bit"
                              className="mainInputField"
                            />
                            <FormControlLabel
                              value="Very"
                              control={<Radio />}
                              label="Very"
                              className="mainInputField"
                            />
                          </RadioGroup>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </div>
              )} */}
              {activeStep === 0 && (
                <>
                  <div className="CommBgMainCard">
                    <Card className="mainCardInput mt-40px">
                      <CardContent className="w-100 CardContentInput">
                        <Grid container spacing={2} className="">
                          <Grid item xs={12}>
                            <Typography
                              variant="h5"
                              className="assessmentQuestion"
                            >
                              Please enter your height and weight.
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              label="Height (cm)"
                              variant="outlined"
                              fullWidth
                              value={secondStepValue.height} // Bind to height in state
                              onChange={handleChangeSecondStep} // Single onChange for both fields
                              className="mainInputField"
                              name="height" // Use name to identify the field
                              type="number" // Restrict input to numbers
                            />
                          </Grid>

                          {/* Weight Input */}
                          <Grid item xs={12}>
                            <TextField
                              label="Weight (kg)"
                              variant="outlined"
                              fullWidth
                              value={secondStepValue.weight} // Bind to weight in state
                              onChange={handleChangeSecondStep}
                              // Single onChange for both fields
                              className="mainInputField"
                              name="weight" // Use name to identify the field
                              type="number" // Restrict input to numbers
                            />
                          </Grid>
                          {/* <Grid item xs={12} className="">
                              <RadioGroup
                                name="satisfaction"
                                value={secondStepValue}
                                onChange={handleChangeSecondStep}
                                className="mainInputField"
                              >
                                <FormControlLabel
                                  value="female"
                                  control={<Radio />}
                                  label="Height (cm)"
                                  className="mainInputField"
                                />

                                <FormControlLabel
                                  value="female"
                                  control={<Radio />}
                                  label="Weight (cm)"
                                  className="mainInputField"
                                />
                              </RadioGroup>
                            </Grid> */}

                          <Grid item xs={12} className="">
                            <p className="subPara">
                              This information helps us calculate your BMI to
                              assess treatment eligibility.
                            </p>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </div>
                </>
              )}
              {activeStep === 1 && (
                <>
                  <div className="CommBgMainCard">
                    <Card className="mainCardInput mt-40px">
                      <CardContent className="w-100 CardContentInput">
                        <Grid container spacing={2} className="">
                          <Grid item xs={12}>
                            <Typography
                              variant="h5"
                              className="assessmentQuestion"
                            >
                              Do you have any allergies to the following
                              substances?
                            </Typography>
                          </Grid>

                          <Grid item xs={12} className="">
                            <FormControlLabel
                              required
                              control={
                                <Checkbox
                                  onChange={handleChangeThirdStep}
                                  checked={thirdStepValue.includes("Minoxidil")}
                                />
                              }
                              label="Minoxidil"
                              name="Minoxidil"
                              className="mainInputField"
                            />
                          </Grid>
                          <Grid item xs={12} className="">
                            <FormControlLabel
                              required
                              control={
                                <Checkbox
                                  onChange={handleChangeThirdStep}
                                  checked={thirdStepValue.includes(
                                    "Dutasteride"
                                  )}
                                />
                              }
                              label="Dutasteride"
                              name="Dutasteride"
                              className="mainInputField"
                            />
                          </Grid>
                          <Grid item xs={12} className="">
                            <FormControlLabel
                              required
                              control={
                                <Checkbox
                                  onChange={handleChangeThirdStep}
                                  checked={thirdStepValue.includes("Biotin")}
                                />
                              }
                              label="Biotin"
                              name="Biotin"
                              className="mainInputField"
                            />
                          </Grid>
                          <Grid item xs={12} className="">
                            <FormControlLabel
                              required
                              control={
                                <Checkbox
                                  onChange={handleChangeThirdStep}
                                  checked={thirdStepValue.includes(
                                    "None of the above"
                                  )}
                                />
                              }
                              label="None of the above"
                              name="None of the above"
                              className="mainInputField"
                            />
                          </Grid>

                          <Grid item xs={12} className="">
                            {thirdStepValue.length > 0 &&
                              !thirdStepValue.includes("None of the above") && (
                                <p className="d-flex justify-content-start align-items-center regretPara">
                                  <InfoIcon></InfoIcon>
                                  We regret to inform you that we are unable to
                                  offer you treatment at this time as a result
                                  of one or more of your responses. If this was
                                  a mistake, please unselect the incorrect
                                  answers and try again.
                                </p>
                              )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </div>
                </>
              )}
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            className="gap-10px"
          >
            {activeStep > 0 ? (
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                className="BorderPreviewButton"
              >
                <div className="d-flex align-items-center gap-10px">
                  <img src={rightArrow} className="prevLeftarrow"></img>
                  <span> Previous </span>
                </div>
              </Button>
            ) : (
              <div></div>
            )}
            {/* {activeStep === 1 && (
              <Button color="inherit" onClick={handleSkip}>
                Skip
              </Button>
            )} */}
            <Button onClick={handleNext} className="NextViewButton">
              {activeStep === 2 ? (
                <div className="d-flex align-items-center gap-10px">
                  <span> Submit</span>
                  <img src={rightArrow} alt="Left Arrow" />
                </div>
              ) : (
                <div className="d-flex align-items-center gap-10px">
                  <span> Next </span>
                  <img
                    src={rightArrow}
                    alt="Left Arrow"
                    className="bgArrowWhite"
                  />
                </div>
              )}
            </Button>
          </Grid>
        </Grid>
        {/* )} */}
        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      </Box>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          }
        }}
        open={open1}
        className="healthdialog1"
        disableBackdropClick
      >
        <div className="closeBtnWrapper">
          <HighlightOffIcon onClick={() => navigate("/resultnew")} />
        </div>
        <DialogTitle id="responsive-dialog-title">
          {"Alopexia is a prescription medicine."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Based on the results of your hair assessment, our medical team will
            determine if Alopexia is suitable for you. If appropriate, a
            licensed doctor will provide a prescription, and your treatment will
            be specially formulated to address your hair concerns. By
            proceeding, you confirm that you understand Alopexia is a
            prescription product and that a medical evaluation is required
            before purchase.
          </DialogContentText>
        </DialogContent>

        <div className="dialogButtonWrapper">
          <button className="buyNowbtn" onClick={() => ProceedNextPg()}>
            Proceed
          </button>
        </div>
      </Dialog>

      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          }
        }}
        open={open2}
        className="healthdialog1"
        disableBackdropClick
      >
        <DialogTitle id="responsive-dialog-title">
          {"You're Eligible for a Prescription! "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Based on your hair test results, you are eligible for a
            prescription. To proceed, please create an account and complete your
            registration.
          </DialogContentText>
        </DialogContent>

        <div className="dialogButtonWrapper">
          <button className="buyNowbtn" onClick={() => ProceedNextPg()}>
            Proceed
          </button>
        </div>
      </Dialog>
    </div>
  );
}
